/**
 * @fileoverview Shared helper to open external http(s) links from the browser.
 * Extracted so multiple persistence clients can reuse it without import cycles.
 */

/** Validate and open an external http(s) URL in a new browser tab. */
export function openExternalInBrowser(url: string): Promise<boolean> {
  try {
    const parsed = new URL(url)
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
      return Promise.resolve(false)
    }
    window.open(parsed.toString(), '_blank', 'noopener,noreferrer')
    return Promise.resolve(true)
  } catch {
    return Promise.resolve(false)
  }
}
